import { useRef } from 'react';

import { getLocalStorageItem } from 'helpers/localStorage';

import { AVAILABLE_THEMES, TRANSFER_POPUP_STORAGE_KEY } from '../constants';
import { PopupTheme } from '../enums';
import { getNextRandomTheme, getRandomTheme } from '../utils';

export const useCurrentTheme = () => {
  const prevTheme = useRef(getLocalStorageItem(TRANSFER_POPUP_STORAGE_KEY));
  const randomTheme = useRef(getRandomTheme(AVAILABLE_THEMES));
  const currentTheme: PopupTheme = prevTheme.current
    ? getNextRandomTheme(Number(prevTheme.current))
    : randomTheme.current;

  return currentTheme;
};
